/// <amd-module name="Dashboards/WidgetHost/MessageComponents/ExtensionDisabledMessage" />
import * as Resources from "Dashboards/WidgetHost/Resources";
import React = require("react");
import { AccessRestrictedImage } from "Reporting/Visuals/VisualMessages/AccessRestrictedImage";
import { VssComponent } from "VSS/Platform/Layout";

/** Detail View for Widgets which seem to be uninstalled or otherwise unavailable from EMS. */
export class ExtensionDisabledMessage extends VssComponent {
    public render(): JSX.Element {
        return (
            <div className={"extension-disabled-dialog-content inline-flex-row"}>
                <span className="flex-self-center">
                    <AccessRestrictedImage />
                </span>
                <span className="flex-self-center">{Resources.ExtensionDisabledWidget_DialogContentText}</span>
            </div>
        );
    }
}
